import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const VideoIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M17.2286 0.771429H0.771429V17.2286H17.2286V0.771429Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

VideoIcon.displayName = 'VideoIcon';
